import React, {
  Component,
} from 'react';
import './Main.scss';
import { BckImg } from '../Common'
import { Link } from 'react-router-dom';
import arrow from './arrow.svg';

class Main extends Component {
  render() {
    return (
      <BckImg
        src="/main.jpg"
        thumb="/main-low.jpg"
        className="main line"
        backgroundStyle={{
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}

      >
        <div  className="column align-self-middle">
          <div className="main__text">
            <h1 className="header">
              Приватная автошкола для<br/>занятых людей
            </h1>
            <h5 className="main__secondary">
              Поможем получить права за 4 месяца всем тем,<br/> кто вечно занят
            </h5>
            <div className="row align-center">
              <Link
                to="/message"
                className="success button large"
              >
                Записаться на обучение
              </Link>
            </div>
            <div className="row align-center">
              <div className="arrow animated bounce">
                <img src={arrow} alt="Запишись" />
              </div>
            </div>
          </div>
        </div>
      </BckImg>
    );
  }
}


export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/Main.jsx